import { useMemo } from "react";
import { useHeldEmail } from "../../../hooks/admin/useSystemEmails";
import { HeldEmailDetailDrawerBody } from "./HeldEmailDetailDrawerBody";

function formatWaitingTime(seconds: number): string {
  if (seconds < 60) return "Less than a minute";
  if (seconds < 3600) return `${Math.floor(seconds / 60)} minutes`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} hours`;
  return `${Math.floor(seconds / 86400)} days`;
}

export function HeldEmailDetailLoader({
  heldEmailId,
}: {
  heldEmailId: string | null;
}) {
  const detail = useHeldEmail(heldEmailId);
  const waitingTime = useMemo(
    () => formatWaitingTime(detail.data?.waitingForSeconds ?? 0),
    [detail.data?.waitingForSeconds]
  );
  return (
    <HeldEmailDetailDrawerBody
      detail={detail.data}
      error={detail.error}
      loading={detail.isLoading}
      waitingTime={waitingTime}
    />
  );
}
